var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.appointmentSelection == 1)?_c('CombinationProductIndex'):(_vm.appointmentSelection == 2 || _vm.appointmentSelection == 3)?_c('CombinationProductIndexTwo'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }